import { useAtom } from 'jotai';

import { editorUiAtom } from '../store/atoms/editorUiAtom';

/**
 * Hook para acessar e atualizar o estado de UI do editor de slides.
 *
 * @returns Estado de UI (zoom, dispositivo ativo, aba do painel) e setter.
 */
export function useEditorUi() {
  return useAtom(editorUiAtom);
}
